module.exports = __webpack_public_path__ + "static/media/urine.9a1a43b5.svg";